import { Trans } from '@lingui/react/macro';
import { Chip, IconButton, Menu, UserAvatar } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Container, LeftCell, RightCell } from './styled';
export function ListItem(props) {
    const { label, description, unreadMessages = 0, pending = false, onClick, onRemove } = props;
    return (<Container>
      <LeftCell $pending={pending} onClick={onClick}>
        <UserAvatar size="md" title={label} subtitle={description}/>
      </LeftCell>
      <RightCell>
        {unreadMessages > 0 && <Chip appearance="danger" label={unreadMessages}/>}
        <Menu.Root target={<IconButton size="xs" appearance="secondary">
              <Falcon icon="ellipsis-h"/>
            </IconButton>}>
          {onClick && (<Menu.Item onClick={onClick}>
              <Trans comment="Label for opening the chat with an external user">Send message</Trans>
            </Menu.Item>)}
          <Menu.Item onClick={onRemove}>
            <Trans comment="Label for removing access for a shared document for an external user">Remove access</Trans>
          </Menu.Item>
        </Menu.Root>
      </RightCell>
    </Container>);
}
